import React from 'react';

function changeClass(v) {
  const n = Number(v);
  if (!Number.isFinite(n) || n === 0) return 'flat';
  return n > 0 ? 'up' : 'down';
}

export default function ScenarioOutlookPanel({ outlook }) {
  if (!outlook) return null;

  return (
    <div className="scenario-panel">
      <div className="scenario-header">
        <span>{outlook.horizon_label || '未来约 5 个交易日'}</span>
        {outlook.confidence ? (
          <span className="decision-muted">置信度：{outlook.confidence === 'medium' ? '中' : '低'}</span>
        ) : null}
      </div>

      {!outlook.scenarios?.length ? (
        <p className="decision-muted">{outlook.disclaimer}</p>
      ) : (
        <div className="scenario-grid">
          {outlook.scenarios.map((s) => (
            <div className={`scenario-card scenario-${s.id}`} key={s.id}>
              <div className="scenario-card-label">{s.label}</div>
              <div className="scenario-metric">
                <span className="decision-muted">合成 5 日</span>
                <span className={changeClass(s.synthetic_5d_pct)}>{s.synthetic_5d_text}</span>
              </div>
              <div className="scenario-metric">
                <span className="decision-muted">产品推算</span>
                <span>{s.product_5d_range_text}</span>
              </div>
              <p className="scenario-drivers">{s.drivers}</p>
            </div>
          ))}
        </div>
      )}

      {outlook.disclaimer ? (
        <p className="decision-muted scenario-disclaimer">{outlook.disclaimer}</p>
      ) : null}
      <p className="decision-muted scenario-link">推演依据见上方「业绩比较基准」成分权重</p>
    </div>
  );
}
